import { render, staticRenderFns } from "./LoanCreation.vue?vue&type=template&id=702d7457&"
import script from "./LoanCreation.vue?vue&type=script&lang=js&"
export * from "./LoanCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports